// extracted by mini-css-extract-plugin
module.exports = {"add":"AddCustomer_add__1lvpR"};